var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { class: { high__footer: !_vm.auth } }, [
    _vm.auth
      ? _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "footer-left" }, [
            _c("p", [_vm._v("Связаться с нами!")]),
            _vm._v(" "),
            _c("p", [
              _c("a", { attrs: { href: "tel:" + _vm.telephone } }, [
                _vm._v(_vm._s(_vm.telephone_visual)),
              ]),
            ]),
            _vm._v(" "),
            _vm._m(0),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "footer-right" }, [
            _c("a", { attrs: { href: _vm.linkURL, target: "_blank" } }, [
              _vm._v(_vm._s(_vm.linkURL_visual)),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("a", { attrs: { href: "mailto:support-rs@sfinx.ru" } }, [
        _vm._v("support-rs@sfinx.ru"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }